import React from 'react';
import { Link } from 'react-router-dom';
import { CompassIcon, HandshakeIcon, PresentationIcon } from 'lucide-react';
const services = [{
  icon: HandshakeIcon,
  title: 'Board Directorship',
  text: 'Independent director service with strength in audit, regulatory readiness and executive oversight for regulated and public companies.'
}, {
  icon: CompassIcon,
  title: 'Strategic Advisory',
  text: 'Counsel to CEOs and boards on government affairs, defense and federal markets, organizational turnaround and crisis response.'
}, {
  icon: PresentationIcon,
  title: 'Keynote Speaking',
  text: 'Keynotes on leadership under pressure, national security and public service — represented by Worldwide Speakers Group.'
}];
export function AdvisoryBand() {
  return <section className="bg-offwhite py-16 lg:py-24" data-id="element-29" data-mp="364p7hinyr8u9">
      <div className="mx-auto max-w-shell px-6 lg:px-8" data-id="element-30" data-mp="362bbn7lglsln">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-31" data-mp="323vl4tq6623h">
          <div className="max-w-2xl" data-id="element-32" data-mp="qfbk41v3end4">
            <h2 className="font-serif text-3xl leading-tight text-navy sm:text-4xl" data-id="element-33" data-mp="qe9yx4kd4kho">
              Blue-Water Strategies
            </h2>
            <p className="mt-4 text-base leading-relaxed text-charcoal" data-id="element-34" data-mp="hf6ffzhaa32n">
              Founder and Chief Executive Officer, advising organizations that operate
              where business, government and public trust intersect.
            </p>
          </div>
          <Link to="/contact" className="inline-flex w-fit items-center border border-navy px-6 py-3.5 text-sm font-semibold text-navy transition-colors duration-150 ease-out hover:bg-navy hover:text-white" data-id="element-35" data-mp="196uly5ddrvdk">
            Start an engagement inquiry
          </Link>
        </div>

        <div className="mt-12 grid gap-px bg-mist md:grid-cols-3" data-id="element-36" data-mp="14czuugvg4e4g">
          {services.map(service => <div key={service.title} className="flex flex-col bg-white p-7" data-id="element-37" data-mp="1wvnb9izhz4z7">
              <service.icon className="h-6 w-6 text-gold-deep" aria-hidden="true" data-id="element-38" data-mp="1wxrpouv0vmdq" />
              <h3 className="mt-5 text-base font-semibold text-navy" data-id="element-39" data-mp="26r424r08u0th">
                {service.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-charcoal" data-id="element-40" data-mp="22nxzrug94tsa">
                {service.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}